"use strict";

exports.__esModule = true;
exports.getDisplayName = void 0;
const getDisplayName = Component => {
  if (typeof Component === 'string') {
    return Component;
  }
  if (!Component) {
    return;
  }
  return Component.displayName || Component.name || 'Component';
};
exports.getDisplayName = getDisplayName;
//# sourceMappingURL=getDisplayName.js.map